import React from 'react';
import Image from '@/src/shared/components/Image';
import styles from './richard-silver-testimonial.module.scss';

export function Stars() {
  return (
    <div className={styles.stars}>
      <Image src={`/images/testimonials/5.svg`} fill alt="5 stars out of 5" />
    </div>
  );
}
